import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { JiraControllerResponse, SupportAccessResponse } from "@ServerTypes/jira/jira.schema";

const ACTION_TO_PATH: Record<string, string> = {
  getList: "getTicketsList",
};

function resolveJiraPath(data: unknown): string {
  let action: string | undefined;
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    try {
      action = JSON.parse((data.get("value") as string) || "{}")?.action;
    } catch {
      action = undefined;
    }
  } else {
    action = (data as { value?: { action?: string } })?.value?.action;
  }
  return `/jira/${(action && ACTION_TO_PATH[action]) || action}`;
}

export const jiraTicketsUrl = `${getBackendUrl()}/jira/getTicketsList`;

export async function fetchIsWhiteListed(): Promise<boolean> {
  const res = await axiosWrapper.get<SupportAccessResponse>(`${getBackendUrl()}/jira/supportAccess`);
  return res.data.isWhiteListed;
}

export async function jiraController(data: unknown) {
  const res = await axiosWrapper.post<JiraControllerResponse>(
    `${process.env.REACT_APP_CUBE_BACKEND}${resolveJiraPath(data)}`,
    data,
  );
  return res;
}
